import { shippingService } from "../_services";
import { router } from "../_helpers";

const initialState = () => ({
  carriers: []
});

const state = initialState();

const actions = {
  getCarriers({ commit, dispatch }) {
    return shippingService
      .getCarriers()
      .then(result => {
        commit("updateCarriers", result.shipping);
      })
      .catch(err => {
        dispatch("user/clearLoginData", null, { root: true });
        dispatch(
          "alert/alert",
          {
            title: "Wystąpił błąd!",
            message: `${
              err.error
            }  Prosimy o wylogowanie się z panelu na hurtowni eromed.pl`
          },
          { root: true }
        );
        router.push("/login");
      });
  }
};

const mutations = {
  reset(state) {
    const s = initialState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  updateCarriers(state, carriers) {
    state.carriers = carriers;
  }
};

const getters = {
  carriers() {
    return state.carriers;
  }
};

export const shipping = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
